export default __webpack_public_path__ + "static/media/fNeutral6.5691e05a.png";